import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router } from '@angular/router';
import { NgbModal, NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, GlobalMessageService, GlobalMessageType } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { LoactionStripService } from "src/app/shared/modules/location-strip/loaction-strip.service";
import { BaseService } from "src/app/shared/services/base.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { ProductUtils } from "src/app/shared/utils/productUtils";
import * as config from '../../../app/shared/config/app.config';
import { ResourcesService } from "../resources.service";

@Component({
  selector: 'app-review-request',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './review-request.component.html',
  styleUrls: ['./review-request.component.scss']
})
export class ReviewRequestComponent implements OnInit, OnDestroy {

  requestItemSubscription: any;
  requestedItemList: any;
  isDeleteClicked = false;
  removeItem: any;
  accountInformation: any;
  userDataSub: Subscription;
  userDetails: any;
  accountInformationSub: Subscription;

  isLocationSelected = false;
  selectedLoc: string = '';
  selectedAccNo: string = '';
  selectedLocSub: Subscription;

  @ViewChild('s3') public popOver: NgbPopover;
  @ViewChild('cardp1', { static: false }) public limitPopover: NgbPopover;
  popoverCloseTimeOut: any;
  baseSiteId: string;
  isQtyLimitExceeded = false;
  selectedCode: any;
  //popoverOpen: boolean[];
  constructor(private readonly service: ResourcesService,
    private readonly modalService: NgbModal,
    private readonly cd: ChangeDetectorRef,
    private router: Router,
    private readonly baseService: BaseService,
    private readonly user: UserAccountFacade,
    private readonly sharedService: SharedService,
    private locService: LoactionStripService,
    private readonly globalMessage: GlobalMessageService,
    private baseSite: BaseSiteService
  ) { }

  ngOnInit(): void {
    this.baseSite.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.selectedLocSub = this.locService.emitSelectedLocs.subscribe(locs => {
      if (locs) {
        this.isLocationSelected = !!locs?.length;
        if (locs.length === 1) {
          this.selectedAccNo = locs[0]?.accountNumber;
          //if (locs[0]?.facilityName2 != undefined || locs[0]?.facilityName2 != null) {
          //   this.selectedLoc = locs[0]?.facilityName + ' ' + locs[0]?.facilityName2 + '(' + this.selectedAccNo + ')';
          // }
          // else {
          this.selectedLoc = locs[0]?.companyName + ' ' + '(' + this.selectedAccNo + ')';
          //}
          this.cd.detectChanges();
        }
        else {
          //take default location from session storage if multiple locations are emitted by location strip
          let locs = this.sharedService.getSessionStorage('defaultLocation');
          if (this.selectedLoc !== undefined || this.selectedLoc! == null || this.selectedLoc == '') {
            this.isLocationSelected = true;
            //this.selectedAccNo = this.getAccNoFromDefaultLoc(this.selectedLoc);
            this.selectedAccNo = locs[0]?.accountNumber;
            // if (locs[0]?.facilityName2 != undefined || locs[0]?.facilityName2 != null) {
            //   this.selectedLoc = locs[0]?.facilityName + ' ' + locs[0]?.facilityName2 + '(' + this.selectedAccNo + ')';
            // }
            // else {
            this.selectedLoc = locs[0]?.companyName + ' ' + '(' + this.selectedAccNo + ')';
            // }
          }
        }
      }
      else {
        //take default location from session storage if no location is emited by location strip
        let locs = this.sharedService.getSessionStorage('defaultLocation');
        if (this.selectedLoc !== undefined || this.selectedLoc! == null || this.selectedLoc == '') {
          this.isLocationSelected = true;
          //this.selectedAccNo = this.getAccNoFromDefaultLoc(this.selectedLoc);
          this.selectedAccNo = locs[0]?.accountNumber;
          // if (locs[0]?.facilityName2 != undefined || locs[0]?.facilityName2 != null) {
          //   this.selectedLoc = locs[0]?.facilityName + ' ' + locs[0]?.facilityName2 + '(' + this.selectedAccNo + ')';
          // }
          // else {
          this.selectedLoc = locs[0]?.companyName + ' ' + '(' + this.selectedAccNo + ')';
          // }
        }
      }
    });

    if (this.service.requestItemValues.getValue()) {
      this.requestItemSubscription = this.service.requestItemValues.subscribe((data) => {
        if (data) {
          this.requestedItemList = data;
          //this.popoverOpen = Array(this.requestedItemList.length).fill(false);
        }
      });
    } 
    else {
      if (localStorage.getItem('requestedItemList')) {
        this.requestedItemList = JSON.parse(localStorage.getItem('requestedItemList'));
       
       
        //this.popoverOpen = Array(this.requestedItemList.length).fill(false);
      }
    }

    this.userDataSub = this.user.get().subscribe((res) => {
      this.userDetails = res;
      this.baseService.get(config.GET_ACCOUNT_ID).subscribe((result) => {
        if (result !== null && result !== undefined && result?.length !== 0) {
          this.accountInformationSub = this.service.getAccountInformation(this.userDetails.userName, result.defaultB2BUnit.uid).subscribe((data) => {
            this.accountInformation = data;
            this.service.accountInformation.next(data);
            this.cd.detectChanges();
          });
        }
      });
    });
  }

  getAccNoFromDefaultLoc(defaultLoc) {
    if (defaultLoc) {
      return defaultLoc?.accountNumber;
    }
    else {
      return '';
    }
  }

  submitRequest() {
    this.requestedItemList.forEach(item => {
      this.getUpdatedProduct(item);
    })
    if (this.isQtyLimitExceeded)
      return;
    const requestsList = this.requestedItemList.map(item => ({
      code: item.code, quantity: +item.units
    }));
    const requestObject = {
      "products": requestsList
    }
    if (!this.selectedAccNo) {
      this.selectedAccNo = this.accountInformation.uid;
    }
    this.service.postPatientEducationRequest(requestObject, this.userDetails.userName, this.selectedAccNo).subscribe((res) => {
      if (res?.status == 'success') {
        this.router.navigate(['resources/category/requestResourcesConfirmationpage']);
        localStorage.setItem('requestedItemList', JSON.stringify(this.requestedItemList));
      }
      else if (res?.status == 'failure') {
        this.globalMessage.add('Something went wrong',
          GlobalMessageType.MSG_TYPE_ERROR);
      }
    }, err => {
      this.globalMessage.add(err.message,
        GlobalMessageType.MSG_TYPE_ERROR);
    }, () => {
      this.router.navigate(['resources/category/requestResourcesConfirmationpage']);
      localStorage.setItem('requestedItemList', JSON.stringify(this.requestedItemList));
    });

  }

  getUpdatedProduct(product) {
    const inputElement = document.getElementById(
      `prodQuantity${product?.code}`
    ) as HTMLInputElement;
    product.units = inputElement.value;
    product.calValue = product.units * product?.quantityPerUnit

    const maxAllowedQty = product?.maxAllowedQuantity ? product?.maxAllowedQuantity : 9999;
    if (product.units > maxAllowedQty) {
      this.isQtyLimitExceeded = true;
      //return;
    }
  }


  getTotalUnits() {
    let totalUnits = 0;
    this.requestedItemList?.forEach(item => {
      totalUnits += +item?.units
    });
    return totalUnits;
  }

  performQuantityComputation(operator, idData, quantityPerUnit = 1, unitType, product, popover?): void {
    const maxAllowedQty = product?.maxAllowedQuantity ? product?.maxAllowedQuantity : 9999;
    // const qtyPerUnit = product?.quantityPerUnit;
    // const limitsUnit = maxAllowedQty/qtyPerUnit;
    const limitsUnit = maxAllowedQty;   // Using same as patient education

    ProductUtils.alterNewQuantity(operator, idData, quantityPerUnit, unitType);
    const inputElement = document.getElementById(
      `prodQuantity${idData}`
    ) as HTMLInputElement;
    const noOfDoses = document.getElementById(
      `noOfDoses${idData}`
    ) as HTMLInputElement;
    const plusIcon = document.getElementById(
      `plusIcon${idData}`
    ) as HTMLElement;
    const unitPlus = document.getElementById(`unitPlus${idData}`);
    const unitPlusDisable = document.getElementById(
      `unitPlusDisable${idData}`
    ) as HTMLElement;

    const currentUnits = +inputElement.value;
    if (currentUnits > limitsUnit) {
      //this.limitPopoverDisplay(popover);
      //this.popoverOpen[popover] = true;
      //plusIcon.classList.add('disabled');
      //unitPlus.classList.add('disabled-img');
      //unitPlusDisable.classList.remove('disabled-img');
      //inputElement.value = String(limitsUnit);
      //noOfDoses.innerHTML = `${limitsUnit * quantityPerUnit}` + ` ` + unitType;
      this.isQtyLimitExceeded = true;
      this.selectedCode = idData;
      popover.open();
    }
    else {
      //plusIcon.classList.remove('disabled');
      //unitPlus.classList.remove('disabled-img');
      //unitPlusDisable.classList.add('disabled-img');
      this.isQtyLimitExceeded = false;
      this.selectedCode = '';
      popover.close();
    }
    product.units = inputElement.value;
    product.calValue = product.units * product?.quantityPerUnit;
  }

  limitPopoverDisplay(popover) {
    clearTimeout(this.popoverCloseTimeOut);
    const num = 3000;
    if (popover) {
      popover?.toggle();
      //this.popoverCloseTimeOut = setTimeout(() => popover?.close(), num);
    }
  }

  deletePopup(popover, item) {
    if (popover.isOpen()) {
      popover.close();
      this.removeItem = null;
    } else {
      popover.open();
      this.removeItem = item;
    }
    // this.cd.detectChanges();
  }

  removeProduct() {
    if (this.removeItem) {
      this.requestedItemList.splice(this.requestedItemList.findIndex(x => x.code === this.removeItem.code), 1);
      this.service.requestItemValues.next(this.requestedItemList);
      this.removeItem = null;
    }
  }

  openCancelModal(modal) {
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
      windowClass: `${this.baseSiteId}`
    })
  }

  cancelRequest() {
    this.modalService.dismissAll();
    this.requestedItemList.splice(0, this.requestedItemList.length);
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  navigateBack() {
    const data = { items: this.requestedItemList };
    this.service.backToDashBoardEmitter.next(data);
    this.service.backtoDashboadItems.push(this.requestedItemList);
    if (this.requestedItemList.length > 0) {
      this.sharedService.removeSessionStorage('isClickedBackToDashboard');
      this.sharedService.setSessionStorage('isClickedBackToDashboard', true);
    }
    // this.router.navigateByUrl('resources/category/mostpopular'); // gives No content page found for this route
    this.router.navigateByUrl('patientEducation');
  }

  ngOnDestroy(): void {
    this.selectedLocSub?.unsubscribe();
    this.userDataSub?.unsubscribe();
    this.accountInformationSub?.unsubscribe();
  }

  validateInput(event) {
    if (event.keyCode === 69) {
      return false;
    }
  }

}
